$(document).ready(function() {
  hideAvailabilityFacets()
});


//document.addEventListener("facet:update", async (event) => {
//  onSoftReload();
//});

window.afterSoftReload = function() {
    infiniteScrollURLTrigger();   // we need to refresh scrolling filtering, but only after first page reload
    hideAvailabilityFacets();
    resetNextPositionAndLinkIndex();
}

//function onSoftReload() { // as soon as soft reload triggers
//}

// Function to hide elements based on caption
function hideAvailabilityFacets() {
    $('.text-subdued').each(function() {
        if ($(this).text().trim() === "Availability: In stock") {
            $(this).parent().addClass('hidden'); // Hide parent element
        }
    });

    $('.text-with-icon').each(function() {
        if ($(this).text().trim() === "Availability")  {
            $(this).parent().addClass('hidden'); // Hide parent element
        }

        if ($(this).text().trim() === "Shop Tops By Size")  {
            $(this).parent().addClass('hidden'); // Hide parent element
        }

        if ($(this).text().trim() === "Shop Bottoms By Size")  {
            $(this).parent().addClass('hidden'); // Hide parent element
        }

        const pattern = /^https:\/\/www\.sartoriale\.com(\/[^\/]+)?\/collections\/coats-jackets.*$/; // https://www.sartoriale.com/*/collections/coats-jackets*  {*} is optional text, the url can be filled with anything there, so it fits filters and locales
        if ($(this).text().trim() === "SUBCATEGORY" && !(pattern.test(window.location.href))) {
            $(this).closest('summary').parent().parent().addClass('hidden'); // Hide parent element
        }

        if ($(this).text().trim() != '' && window.location.href.includes("collections")) { //hiding every filter group that has less than 2 options
            var count = $(this)
                .closest('details')
                .find('.checkbox-control')
                .length;
            count += $(this)
                .closest('details')
                .find('.color-swatch')
                .length;

            if (count <= 1) {
                $(this).closest('details').parent().addClass('hidden');
            }
        }
    });

    const EU_ISO_CODES = [
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'HR', // Croatia
    'CY', // Cyprus
    'CZ', // Czechia
    'DK', // Denmark
    'EE', // Estonia
    'FI', // Finland
    'FR', // France
    'DE', // Germany
    'GR', // Greece
    'HU', // Hungary
    'IE', // Ireland
    'IT', // Italy
    'LV', // Latvia
    'LT', // Lithuania
    'LU', // Luxembourg
    'MT', // Malta
    'NL', // Netherlands
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SK', // Slovakia
    'SI', // Slovenia
    'ES', // Spain
    'SE'  // Sweden
    ];

if (!EU_ISO_CODES.includes(window.iso_code)) {
  $('a').each(function () {
    if ($(this).text().trim() === 'EU RIGHT OF WITHDRAWAL') {
      $(this).parent().addClass('hidden');
    }
  });
}

if (window.location.href.includes('www.sartoriale.com/pages/eu-right-of-withdrawal')) {
    const button = document.querySelector('#eu-return');
    const realButton = button.querySelector('button');
    const target = document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
    const checkbox = document.querySelector('#terms-checkbox');

    if (button && target) {
        target.appendChild(button);
        button.classList.remove('hidden');
        button.classList.add('centered-div');
    }

    if (button && checkbox) {
        // initial state
        realButton.disabled = !checkbox.checked;

        checkbox.addEventListener('change', function () {
            realButton.disabled = !checkbox.checked;
        });
    }
}




    /// Decrease the Filter (n) text on filter selector in phone layout so it wont count the basic "in-stock" filter
    /*
    $(".collection-toolbar__button").each(function() {
        var regex = /^Filter \((.*)\)$/;  // Regular expression to match "Filters (n)" where n is a number
        var text = $(this).text().trim(); // Get the text content and trim whitespace
        var match = text.match(regex)
        if (match) {
            var originalNumber = parseInt(match[1], 10); // Convert the captured number to an integer
            var newNumber = Math.max(0, originalNumber - 1); // Decrement the number by one, ensuring it's not 
            if (newNumber > 0) {
                var newText = `Filter (${newNumber})`; // Create the new text
            } else {
                var newText = `Filter`; // Create the new text without number
            }
            $(this).text(newText); // Update the element's text
        }
    });
    */
}
